import { Box, MenuItem, Tabs, Tab } from '@mui/material';
import { CustomSelect } from '../../../../common/components';

const LotsHeaderControls = ({
  allotments = [],
  selectedAllotment,
  onSelectAllotment,
  view,
  onViewChange,
}) => {
  return (
    <Box sx={{ display: 'grid', gap: 2, bgcolor: 'background.paper', p: 2 }}>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
        <CustomSelect
          label="Loteo"
          name="uuid_allotment"
          value={selectedAllotment}
          onChange={onSelectAllotment}
        >
          <MenuItem value="">Seleccionar loteo</MenuItem>
          {allotments.map((allotment) => (
            <MenuItem key={allotment.uuid} value={allotment.uuid}>
              {allotment.name}
            </MenuItem>
          ))}
        </CustomSelect>
      </Box>

      <Tabs value={view} onChange={(_, value) => onViewChange(value)}>
        <Tab value="plan" label="Plano" />
        <Tab value="table" label="Tabla" />
      </Tabs>
    </Box>
  );
};

export default LotsHeaderControls;
